(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["marquee"] && !window.DesignMode) return;
  try {
    
window.addEventListener('DOMContentLoaded', function() {
  createMarqueeInstance();
  

  document.addEventListener('shopify:section:load', function(e) {
    const sectionId = e.detail.sectionId;

    createMarqueeInstance(sectionId);
  });

  document.addEventListener('shopify:section:unload', function(e) {
    const sectionId = e.detail.sectionId;

    for (elem of window.marqueeInstances) {
      if (elem.id === sectionId) {
        elem.instance.clear();
        window.marqueeInstances.splice(window.marqueeInstances.indexOf(elem), 1);
        return;
      }
    }
  });

  function createMarqueeInstance(sectionId = null) {
    if (sectionId === null) {
      const containers = document.querySelectorAll(`[data-section-type="marquee"]`);
      containers.forEach(function(container) {
        const target = container.querySelector('.Marquee');

        setTimeout(function() {
          const marquee = new dynamicMarquee.Marquee(target, {
            rate: -50,
            startOnScreen: true
          });

          const marqueeLoop = new dynamicMarquee.loop(
            marquee,
            [
              function() {
                return container.querySelector(`[data-content]`).innerHTML + ' ';
              }
            ]
          );

          window.marqueeInstances.push({
            'id': container.id.replace('section-', ''),
            'instance': marquee,
            'loop': marqueeLoop
          });
        }, 50);
      });
    } else {
      const container = document.querySelector(`#section-${ sectionId }`);
      const target = container.querySelector('.Marquee');
      let found = false;

      for (elem of window.marqueeInstances) {
        if (elem.id === sectionId && !found) {
          elem.loop.update(
            [
              function() {
                return container.querySelector(`[data-content]`).innerHTML + ' ';
              }
            ]
          );

          found = true;
        }
      }

      if (!found) {
        setTimeout(function() {
          const marquee = new dynamicMarquee.Marquee(target, {
            rate: -50,
            startOnScreen: true
          });

          const marqueeLoop = new dynamicMarquee.loop(
            marquee,
            [
              function() {
                return container.querySelector(`[data-content]`).innerText + ' ';
              }
            ]
          );

          window.marqueeInstances.push({
            'id': sectionId,
            'instance': marquee,
            'loop': marqueeLoop
          });
        }, 50);
      }
    }
  }

  
});

  } catch(e) { console.error(e); }
})();

})();
